<template>
  <v-tabs
    height="unset"
    :dark="dark"
    left
    :color="color"
  >
    <template v-for="nav in navigation">
      <v-tab
        v-if="!nav.hidden"
        :key="nav.title"
        :to="nav.src"
        class="font-weight-regular text-none text-subtitle-1 px-0 mx-3"
        active-class="font-weight-negrita"
      >
        {{ nav.title }}
      </v-tab>
    </template>
  </v-tabs>
</template>

<script>
  import { get } from 'vuex-pathify'
  export default {
    props: {
      dark: {
        type: Boolean,
        default: false,
      },
      color: {
        type: [String, Boolean],
        default: false,
      },
    },
    data () {
      return {
        currentItem: {
          title: 'Panel',
          src: '/',
        },

      }
    },
    computed: {
      group: get('user/group'),
      clienteInterno: get('user/clienteInterno'),
      navigation () {
        const idDestino = this.clienteInterno.unidad && this.clienteInterno.unidad !== '' ? `/${this.clienteInterno.unidad}` : ''
        return [
          {
            title: 'Pedidos',
            src: `/cliente/${this.clienteInterno.id_cliente}${idDestino}`,
            hidden: this.group === 'admin' || this.group === 'proveedor',
          },
          {
            title: 'Panel',
            src: '/',
            hidden: this.group === 'admin' || this.group === 'clienteInterno',
          },
          {
            title: 'Clientes',
            src: '/clientes',
            hidden: this.group === 'admin' || this.group === 'clienteInterno',
          },
          {
            title: 'Remitos',
            src: '/remitos',
            hidden: this.group === 'admin' || this.group === 'clienteInterno',
          },
          {
            title: 'Usuarios',
            src: '/usuarios',
            hidden: this.group === 'proveedor' || this.group === 'clienteInterno',
          },
          {
            title: 'Admins',
            src: '/usuarios/alta',
            hidden: this.group === 'proveedor' || this.group === 'clienteInterno',
          },
        ]
      },
    },
  }
</script>

<style scoped>
.v-tab{
  min-width: unset;
}
</style>
